import React from 'react'
import PartnerUserListComponent from '../Components/PartnerList/PartnerUserListComponent'

function PartnerUserPage() {
    return (

        <PartnerUserListComponent/>
    )
}

export default PartnerUserPage